module.exports = "  .textBold {\r\n      font-weight: 600;\r\n  }\r\n  \r\n  .dropdown {\r\n      display: inline;\r\n  }\r\n  \r\n  .caret {\r\n      display: inline-block;\r\n      width: 0;\r\n      height: 0;\r\n      margin-left: 2px;\r\n      vertical-align: middle;\r\n      border-top: 6px dashed;\r\n      border-right: 6px solid transparent;\r\n      border-left: 6px solid transparent;\r\n      color: #fff;\r\n      cursor: pointer;\r\n  }\r\n  \r\n  .dropdown-menu {\r\n      right: 0;\r\n      left: auto !important;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/sidebar/sidebar.component.css
// module id = ./src/app/common/sidebar/sidebar.component.css
// module chunks = main